export default __webpack_public_path__ + "static/media/Walt.c68b28c1.ttf";